module.exports = __webpack_public_path__ + "media/assets/images/category/ValentinesDay@2x-3d51d236996ac0326181389b3587ae5a.png";